// extracted by mini-css-extract-plugin
module.exports = {"button":"_42b09c6","message":"_c6993b3"};